import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { BehaviorSubject, map, Observable, of } from "rxjs";
import { environment } from "../../environments/environment.prod";

@Injectable({
  providedIn: "root",
})
export class CustomerServiceService {
  public data = new BehaviorSubject<any>(null);
  public share = this.data.asObservable();
  constructor(
    private httpClient: HttpClient,
    private cookieService: CookieService
  ) {}

  customerLogin(loginData: any) {
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}verification`,
        loginData
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  userCustomerVerify(obj: any): Observable<any> {
    return this.httpClient
      .post(`${environment.base_url}${environment.base_uri}admin/sendotp`, obj)
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  cancelQuote(cancelQuote: any, token: any) {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `
        ${environment.base_url}${environment.base_uri}trip-booking/quote/cancel`,
        cancelQuote,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  acceptQuote(token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}trip-booking/quote/accept/${id}`,
        {},
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  truckownerDriverLogin(loginData: any) {
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}verification/truckowner/driver/sendotp`,
        loginData
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  OTPVerify(data: any, id: any) {
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}verification/${id}`,
        data
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  newRegister(data: any, id: any): Observable<any> {
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}verification/register/${id}`,
        data,
        { observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  GetProfile(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(`${environment.base_url}${environment.base_uri}profile`, {
        headers: header,
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  UpdateProfile(profileData: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}profile`,
        profileData,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  verifyGST(gstin: string, token?: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + (token || sessionStorage.getItem("token") || ""),
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}master-india/gst`,
        { gstin: (gstin || "").trim().toUpperCase() },
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  verifyPAN(pan: string, token?: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + (token || sessionStorage.getItem("token") || ""),
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}master-india/pan`,
        { pan: (pan || "").trim().toUpperCase() },
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  uploadImage(file: any): Observable<any> {
    var fd = new FormData();
    fd.append("upload", file);
    return this.httpClient
      .post(`${environment.base_url}${environment.base_uri}upload`, fd, {
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  verifyOTP(data: any, id: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    let userDataObj = {
      user_type: data.user_type,
      mobile: data.mobile,
      code: data.code,
    };
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}admin/verify/${data.ref_id}`,
        data,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  EmailOTPVerify(data: any, id: any): Observable<any> {
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}verification/email/${id}`,
        data,
        { observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  GetCategory(): Observable<any> {
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truck-details/category`,
        { observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  GettruckWeight(category: string): Observable<any> {
    if (!category || typeof category !== "string" || category.trim() === "") {
      return of({ status: 200, body: { data: [] } });
    }
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truck-details/cat/type/${category}`,
        { observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  tripSearchBestRoute(details: any, token?: any): Observable<any> {
    let header = new HttpHeaders();
    if (token) {
      header = header.set("Authorization", "Bearer " + token);
    }
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}trip-booking/search`,
        details,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  SearchTruckDetails(details: any, token?: any): Observable<any> {
    let header = new HttpHeaders();
    if (token) {
      header = header.set("Authorization", "Bearer " + token);
    }
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}trip-booking/DRO_search`,
        details,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  generateELR(trip_id: string, token: string): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + token,
    });

    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}trip-booking/elr/${trip_id}`,
        {},
        { headers, observe: 'response' } // ✅ options
      )
      .pipe(map((response) => response));
  }

  updateELR(trip_id: string, payload: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + token,
    });

    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}trip-booking/elr/${trip_id}`,
        payload,
        { headers, observe: 'response' }
      )
      .pipe(
        map((response) => response)
      );
  }


  downloadELR(token: any, tripId: any, elr_id: any): Observable<any> {
    let header = new HttpHeaders({
      // Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}pdf/generate-elr/${tripId}/${elr_id}`,
        {
          headers: header,
          observe: "response",
          responseType: "blob" as "json"   // Important for PDF download
        }
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  DriverUpdatePrice(driver_id: string, token: string): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
  
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}customer/driverupdateprice/${driver_id}`,
        { headers: headers, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  GetLoadDetails(token?: any): Observable<any> {
    let headersConfig: any = {};
    if (token) {
      headersConfig["Authorization"] = "Bearer " + token;
    }
    let header = new HttpHeaders(headersConfig);
    return this.httpClient
      .get(`${environment.base_url}${environment.base_uri}load-details`, {
        headers: header,
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  GetTaxdetails(hsn_code?: string): Observable<any> {
    let url = `${environment.base_url}${environment.base_uri}taxes/customer`;
    // ✅ If hsn_code exists, append it as a query param
    if (hsn_code) {
      url += `?hsn_code=${hsn_code}`;
    }
    return this.httpClient
      .get(url, { observe: 'response' })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  
  GetTripList(
    token: any,
    fetch_page: number,
    trip_type: string,
    tripNumber: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}trip-booking?page=${fetch_page}&status=${trip_type}&search_query=${tripNumber}`,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  TripBooking(bookingData: any, token: any, trip_id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}trip-booking/update/${trip_id}`,
        bookingData,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  TripPayment(paymentData: any, trip_id: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}trip-booking/payment/${trip_id}`,
        paymentData,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  cancellationTrip(id: any, tripData: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}trip-booking/trip_cancel/${id}`,
        tripData,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  TripBookingGetId(details: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}trip-booking`,
        details,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  findExactTruck(details: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}trip-booking/find-exact-truck`,
        details,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  GeneratePaymentOrder(tripData: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}trip-booking/generate/payment/order`,
        tripData,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  updatePaymentResponse(token: any, payload: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}trip-booking/payment/response/${id}`,
        payload,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  dashboard(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(`${environment.base_url}${environment.base_uri}customer/dashboard`, {
        headers: header,
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  Track(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(`${environment.base_url}${environment.base_uri}truckowner/track`, {
        headers: header,
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  customerTrack(token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}trip-booking/truckhistory/${id}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  latestLocation(token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}trip-booking/latest-location/${id}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  tracking(token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}customer/trip/${id}/track`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  accountDelete(userType: any, data: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}profile/userstatus?status=${userType}&mobile=${data}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  accountRestore(restoreUser: any, data: any): Observable<any> {
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}profile/userstatus?status=${restoreUser}&mobile=${data}`,
        {
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  customerLogout(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}customer/dashboard/logout`,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
}
